import { apiCall } from '@/lib/api-client';

export interface CountryEntry {
  code: string;
  label: string;
}

/**
 * GET /api/countries — operator-configured catalog of countries to surface
 * in agent dispatch pickers (predicate finder, strategy, protocol, report,
 * dossier). Driven by the backend's ``COUNTRIES_ENABLED`` env var. Order
 * in the response matches the order the operator set; render dropdowns
 * in that order without re-sorting.
 *
 * Distinct from the static ISO 3166-1 list in ``iso-countries.ts``, which
 * powers Country of Incorporation / HQ Country (where ALL countries are
 * valid). This catalog is the narrower agent-dispatch jurisdiction list.
 */
export async function getCountries(
  productType?: string | null,
): Promise<CountryEntry[]> {
  const query = productType
    ? `?product_type=${encodeURIComponent(productType)}`
    : '';
  return apiCall<CountryEntry[]>(`/api/countries${query}`, { method: 'GET' });
}

/** Which product categories may currently be CREATED (admin Target-markets
 *  dial). Existing products of a disabled type stay visible and dispatchable. */
export interface ProductTypeEnablement {
  device: boolean;
  drug: boolean;
  biologic: boolean;
}

export async function getProductTypeEnablement(): Promise<ProductTypeEnablement> {
  return apiCall<ProductTypeEnablement>('/api/product-types', { method: 'GET' });
}
